import CreateAccountForm from './CreateAccountForm';

export default CreateAccountForm;
